
export interface FeatureRecognizeRequest {
    task_id: string;
}

export interface FeatureRecognizeResponse {
    text: string;
    features: {
        keywords: string[];
        score: number;
        tech_feature: string;
    }[];
    /**
     * 阈值
     */
    threshold: number;
}

/**
 * 特征识别 API
 */
export interface FeatureRecognizeApi {
    /**
     * 识别特征
     * @param data 识别特征请求
     * @returns 识别特征响应
     */
    recognize(data: FeatureRecognizeRequest): Promise<FeatureRecognizeResponse>;
}

export const FeatureRecognizeApi = Symbol.for('FeatureRecognizeApi');

